<firebird-web-shared-dialog
  [title]="
    ((currentState$ | async) === 'noAccount'
      ? 'enterWSICredentials'
      : 'importCustomListsWSI'
    ) | translate
  "
  [cancelText]="cancelButtonText()"
  [confirmText]="
    ((currentState$ | async) === 'noAccount' ? 'continue' : 'import')
      | translate
  "
  (confirm)="onConfirm()"
  [showConfirmButton]="areAnyCustomLocations()"
>
  <div class="dialog__content">
    @switch (currentState$ | async) {
    <!-- Loading -->
    @case ('loading') {
    <firebird-web-loader class="dialog__loader"></firebird-web-loader>
    }
    <!-- No Account Case -->
    @case ('noAccount') {
    <div class="dialog__content-no-account">
      @if (!isProfileError) {
      <p>
        We did not find a WSI profile matching your AG2 Trader login. If your
        WSI Trader Profile ID is different than your AG2 Trader login, enter it
        below. If you believe this was an error, please contact Customer Support
        at
        <a href="mailto:support&#64;atmosphericg2.com"
          >support&#64;atmosphericg2.com</a
        >
      </p>
      } @if (isProfileError) {
      <div class="dialog__profile-error">
        <firebird-web-icon
          class="dialog__profile-error-icon"
          name="alert-circle"
          width="20px"
          height="20px"
        ></firebird-web-icon>
        <p>
          No matches found for the WSI Trader Profile ID entered, try again or
          contact support at:
          <a href="mailto:support&#64;atmosphericg2.com"
            >support&#64;atmosphericg2.com</a
          >
        </p>
      </div>
      }
      <div class="dialog__input-wrapper">
        <span class="dialog__input-label">WSI Trader Profile ID</span>
        <mat-form-field
          class="dialog__form-field import-list-dialog-form-field"
          floatLabel="auto"
        >
          <input
            matInput
            type="text"
            placeholder="Enter your WSI Trader Profile ID"
            class="dialog__form-field__input"
            [formControl]="profileControl"
          />
        </mat-form-field>
      </div>
    </div>
    }
    <!-- Multiple Case -->
    @case ('multipleAccounts') {
    <div class="dialog__content-no-account">
      <p>
        We located multiple WSI Trader accounts associated with your email
        address.
      </p>
      <br />
      <p>
        Please contact Customer Support for assistance:
        <a href="mailto:support&#64;atmosphericg2.com"
          >support&#64;atmosphericg2.com</a
        >
      </p>
    </div>
    }
    <!-- There are custom locations case -->
    @case ('locations') { @if (isErrorMsgVisible) {
    <div class="dialog__content-error">
      <firebird-web-icon
        class="dialog__content-error-icon"
        name="alert-circle"
        width="20px"
        height="20px"
      ></firebird-web-icon>
      <div
        class="dialog__content-error-message"
        translate="selectOneList"
      ></div>
    </div>
    }
    <div class="dialog__content-select-all">
      <div style="display: flex">
        <firebird-web-checkbox
          [labelKey]="'selectAll' | translate"
          [checked]="(isSelectedAll$ | async) || false"
          (change)="onSelectAllChange($event)"
        >
        </firebird-web-checkbox>
      </div>
      <mat-divider></mat-divider>
    </div>
    <ul class="dialog__content-list">
      @for (list of lists; track trackByList($index, list)) {
      <li class="dialog__content-list-item">
        <label class="dialog__content-member">
          <div class="dialog__list-item">
            <firebird-web-checkbox
              [checked]="list.checked"
              (change)="onCheckboxChange(list.listId, $event)"
            ></firebird-web-checkbox>
            <span firebirdWebEllipsisTooltip [tooltipText]="list.listName">{{
              list.listName
            }}</span>
          </div>
        </label>
      </li>
      }
    </ul>
    }
    <!-- There are no custom location case -->
    @case ('noLocations') {
    <div class="dialog__no-content">
      <p [innerHTML]="'noCustomLocations' | translate"></p>
    </div>
    } }
  </div>
</firebird-web-shared-dialog>
